import { cdnTemplate } from 'cdnPreprocessor';

export default [
  'SupportService',
  function contactFormDirective(supportService) {
    return {
      restrict: 'E',
      templateUrl: cdnTemplate('/contact-form.html'),
      scope: {
        category: '=?',
        type: '@?'
      },
      link: (scope, attrs) => {
        scope.categories = [
          'General Inquiry',
          'Order Status',
          'Billing Issue',
          'Seller Support',
          'Sales'
        ];
        scope.data = {
          name: '',
          email: '',
          category: scope.category,
          message: '',
          _email: ''
        }
        scope.type = attrs.type || 'CONTACT';
        scope.submitState = null;

        scope.$watch('category', (val) => {
          if (val) {
            scope.data.category = val;
          }
        })

        scope.sendMessage = () => {
          if (scope.contactForm.$valid) {
            scope.submitState = 'loading';

            let fullCategory = _.find(scope.categories, (category) => category === scope.data.category) ? getFullCategory() : getFullPartnershipCategory();

            supportService.sendMessage(
              scope.data.name,
              scope.data.email,
              fullCategory,
              scope.data.message,
              scope.data._email,
              scope.type
            ).then((res) => {
              scope.submitState = 'success';
              scope.data.name = '';
              scope.data.email = '';
              scope.data.category = '';
              scope.data.message = '';
              scope.data._email = '';
              scope.contactForm.$setPristine();
            }).catch((err) => {
              scope.submitState = 'error';
            });
          }
        }

        function getFullCategory() {
          return `Contact Form - ${scope.data.category}`;
        };

        function getFullPartnershipCategory() {
          return `Partnership Contact - ${scope.data.category}`;
        };
      }
    }
  }
]


// WEBPACK FOOTER //
// ./source/client/layout-components/contact-form/contact-form.dir.js